var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m494.9,28.4c-8.1-7.9-21-7.8-28.9,0.3l-111.5,113.5c-33.6-6.4-71-9.6-108.2-9.6-22.4,0-44.9,1.2-66.5,3.5l-117-119c-7.9-8-20.8-8.2-28.8-0.2-8,7.9-8.2,20.8-0.3,28.9l96.3,98.1c-68.1,14.1-119,41.5-119,81.4v183c0,60.8 118.3,92.7 235.2,92.7 116.9,0 235.2-31.8 235.2-92.7v-183c0-32.1-32.9-56-81-71.6l94.7-96.5c7.9-8 7.8-20.9-0.2-28.8zm-54.3,379.9c0,15.5-66.1,51.8-194.4,51.8-128.3,0-194.4-36.3-194.4-51.8v-128.5c44.7,25.2 119.8,38.2 194.4,38.2 74.6,0 149.8-13 194.4-38.1v128.4zm0-183c0,15.5-66.1,51.8-194.4,51.8-128.3,0-194.4-36.3-194.4-51.8 0-11.8 38.2-35.6 112.7-46.3l28.1,28.6c5.1,5.6 18.5,10.6 28.9,0.3 8-8 9.3-23.4-4.5-33.7 0,0 19.1-0.7 29.2-0.7 27.2,0 51.7,1.6 73.3,4.4l-32.5,33.1c-7.9,8-7.7,20.9 0.3,28.9 10.3,10.3 23.6,5 28.9-0.3l51.9-52.9c48,12 72.5,29.2 72.5,38.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrum);
export default __webpack_public_path__ + "static/media/drum.bdd4e4d8925c971b9e8be0f7c6ad6ecd.svg";
export { ForwardRef as ReactComponent };